import { NativeEvent } from '../NativeEvent';

export class BiometricDisableEvent extends NativeEvent<
  'biometricDisable',
  Record<string, never>
> {
  readonly type = 'biometricDisable';
  readonly payload: Record<string, never> = {};
}
